import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

export const useThemeStore = defineStore('theme', () => {
  // État
  const isDarkMode = ref(false)
  const isChangingTheme = ref(false) // Nouvel état pour indiquer que le thème est en cours de changement
  
  // Valeurs par défaut pour la réinitialisation
  const defaultIsDarkMode = false
  const defaultIsChangingTheme = false
  
  // Initialiser le mode sombre en fonction des préférences de l'utilisateur
  const initializeTheme = () => {
    // Vérifier si l'utilisateur a déjà une préférence enregistrée
    const savedTheme = localStorage.getItem('theme')
    
    if (savedTheme) {
      // Utiliser la préférence enregistrée
      isDarkMode.value = savedTheme === 'dark'
    } else {
      // Utiliser le mode clair par défaut au lieu des préférences système
      isDarkMode.value = false
      // Enregistrer cette préférence
      localStorage.setItem('theme', 'light')
    }
    
    // Appliquer le thème
    applyTheme()
  }
  
  // Basculer entre les modes clair et sombre
  const toggleDarkMode = () => {
    // Si le thème est déjà en cours de changement, ne rien faire
    if (isChangingTheme.value) return
    
    // Indiquer que le thème est en cours de changement
    isChangingTheme.value = true
    
    isDarkMode.value = !isDarkMode.value
    
    // Enregistrer la préférence
    localStorage.setItem('theme', isDarkMode.value ? 'dark' : 'light')
    
    // Appliquer le thème
    applyTheme()
    
    // Réactiver le bouton après un délai
    setTimeout(() => {
      isChangingTheme.value = false
    }, 1000) // Délai de 1 seconde
  }
  
  // Appliquer le thème à l'élément HTML
  const applyTheme = () => {
    if (isDarkMode.value) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }
  
  // Méthode personnalisée pour réinitialiser le store
  function $reset() {
    isDarkMode.value = defaultIsDarkMode
    isChangingTheme.value = defaultIsChangingTheme
    // Réinitialiser le thème dans localStorage
    localStorage.setItem('theme', 'light')
    // Appliquer le thème réinitialisé
    applyTheme()
  }

  return {
    isDarkMode,
    isChangingTheme,
    initializeTheme,
    toggleDarkMode,
    $reset
  }
})

